import { system } from '@styled-system/core';
export var shadow = system({
  boxShadow: {
    property: 'boxShadow',
    scale: 'shadows'
  },
  textShadow: {
    property: 'textShadow',
    scale: 'shadows'
  }
});
export default shadow;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@styled-system/shadow/dist/index.esm.js
// module id = 146
// module chunks = 0